export const FORM_CLOSE_EVENT = '$$FeedbackFormClose';
export const GLOBAL_STRUCTURE_KEY = '__structure';
export const GLOBAL_METADATA_KEY = '__metadata';
export const GLOBAL_LANGUAGE_KEY = '__language';
export var FormCloseReason;
(function (FormCloseReason) {
    FormCloseReason["Timeout"] = "timeout";
    FormCloseReason["Submitted"] = "submitted";
    FormCloseReason["Closed"] = "closed";
})(FormCloseReason || (FormCloseReason = {}));
//# sourceMappingURL=common.js.map